import { Popup, Text } from 'common-components'

import * as Styled from './styled'
import { useAlertPopupsContext } from 'context/AlertPopups'

const ConfirmationPopup = () => {
  const {
    alertPopupsData: {
      confirmationPopup: {
        title,
        description,
        imageSrc,
        buttons: {
          cancel: { label: cancelButtonLabel, onClick: onCancelBtnClick } = {},
          confirm: { label: confirmButtonLabel, onClick: onConfirmBtnClick }
        }
      }
    },
    resetAlertPopupsData
  } = useAlertPopupsContext()

  const handleCancelClick = () => {
    onCancelBtnClick?.()
    resetAlertPopupsData()
  }

  const handleConfirmClick = () => {
    onConfirmBtnClick?.()
    resetAlertPopupsData()
  }

  const handleClose = () => {
    resetAlertPopupsData()
  }

  return (
    <Popup
      isOpen={!!title}
      onClose={handleClose}
      className="confirmation-popup"
    >
      <Styled.Container>
        {imageSrc && <Styled.Image src={imageSrc} alt="confirmation" />}
        {title && (
          <Styled.ConfirmationTitle>
            <Text
              type="h1"
              color="secondaryExtraDark"
              fontWeight="600"
              align="center"
              className="confirmation-title"
            >
              {title}
            </Text>
          </Styled.ConfirmationTitle>
        )}
        {description && (
          <Styled.ConfirmationDescription>
            <Text
              type="p"
              color="secondarySemiDark"
              align="center"
              className="confirmation-description"
            >
              {description}
            </Text>
          </Styled.ConfirmationDescription>
        )}
        <Styled.ButtonsWrapper>
          {cancelButtonLabel && (
            <Styled.ActionButton type="white" onClick={handleCancelClick}>
              {cancelButtonLabel}
            </Styled.ActionButton>
          )}
          {confirmButtonLabel && (
            <Styled.ActionButton type="primary" onClick={handleConfirmClick}>
              {confirmButtonLabel}
            </Styled.ActionButton>
          )}
        </Styled.ButtonsWrapper>
      </Styled.Container>
    </Popup>
  )
}

export default ConfirmationPopup
